import { FluentProvider } from '@fluentui/react-components';
import { DatePicker } from '@fluentui/react-datepicker-compat';
import { parseUtcDate } from '@moko/utils';
import { useActiveTheme } from '../../theme/ThemeContext';
import { useOtherInfoContext } from '../OtherInfoContext';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

export const DateField = ({
  field,
  fieldValue,
  isFieldDisabled,
  validationMessage,
}: FieldComponentProps) => {
  const { handleOtherInfoChange, validateField } = useOtherInfoContext();
  const theme = useActiveTheme();

  const parsed = fieldValue ? parseUtcDate(fieldValue as string | Date) : null;
  const value = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;

  return (
    <FieldWrapper field={field} validationMessage={validationMessage}>
      <FluentProvider theme={theme} style={{ width: '100%', minWidth: 0 }}>
        <DatePicker
          style={{ width: '100%', minWidth: 0 }}
          value={value}
          isMonthPickerVisible={false}
          onSelectDate={(selectedDate: Date | null | undefined) => {
            const iso = selectedDate?.toISOString();
            handleOtherInfoChange(field.name, iso);
            validateField(field.name, iso);
          }}
          disabled={isFieldDisabled}
        />
      </FluentProvider>
    </FieldWrapper>
  );
};
